module.exports = __webpack_public_path__ + "static/media/IMG_0683.e0effca8.jpg";